import Instrument from 'src/models/instrument';

export const Instruments: Instrument[] = [
  {
    id: 1,
    name: 'LOG03 T-TEC',
    ftp_ip: 'tteclog03.lainit.it',
    ftp_user: 'mike',
    ftp_password: '3005',
  },
  {
    id: 2,
    name: 'LOG01 T-TEC',
    ftp_ip: '10.214.61.2:5900',
    ftp_user: 'mike',
    ftp_password: '3005',
  },
  {
    id: 3,
    name: 'LOG02 T-TEC',
    ftp_ip: '10.214.57.2',
    ftp_user: 'mike',
    ftp_password: '3005',
  },
  {
    id: 4,
    name: 'LOG04 T-TEC',
    ftp_ip: '10.214.78.2',
    ftp_user: 'mike',
    ftp_password: '3005',
  },
  {
    id: 6,
    name: 'LOG05 T-TEC',
    ftp_ip: '10.214.64.2',
    ftp_user: 'mike',
    ftp_password: '3005',
  },
  {
    id: 7,
    name: 'LOG06 T-TEC',
    ftp_ip: '10.212.238.2',
    ftp_user: 'mike',
    ftp_password: '3005',
  },
];
